document.addEventListener('change', function(e){

  if(!e.target.matches('.swatch-element input[type="radio"]')) return;

  const swatch = e.target.closest('.swatch-element');

  if(!swatch) return;

  const carveProduct = swatch.dataset.carveProduct;
  const carvePrice = swatch.dataset.carvePrice;
  const carvePriceRaw = swatch.dataset.carvePriceRaw;
console.log(carvePriceRaw);
  // Update product id
  const carveOptions = document.querySelector('.second-side-carve-options');
  if(carveOptions && carveProduct){
    carveOptions.setAttribute('data-product-id', carveProduct);
  }

  // Update checkbox price
  const checkbox = document.querySelector('#second-side-checkbox');
  if(checkbox && carvePrice){
    checkbox.setAttribute('data-price', carvePrice);
  }

  // Update price text
  const priceText = document.querySelector('.second-side-carve-options-field-name-content');
  if(priceText && carvePrice){
    priceText.innerText = `Second Side Engraving (+${carvePriceRaw})`;
  }

});

/////////////////// for wholesale page upload btn //////////////////
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.custom-file-upload input[type="file"]')) return;

    const input = e.target;
    const file = input.files && input.files[0];
    if (!file) return;

    const uploadSection = input.closest('.upload-section');
    const buttonText = uploadSection.querySelector('.button-text');
    const progress = uploadSection.querySelector('.upload-progress');
    const bar = uploadSection.querySelector('.upload-progress-bar');

    // Show file name
    if (buttonText) {
      buttonText.textContent = file.name;
    }

    input.closest('.custom-file-upload').classList.add('file-selected');

    // Show progress bar
    progress.style.display = 'block';
    bar.style.width = '0%';

    // Fake progress animation
    let percent = 0;
    const interval = setInterval(() => {
      percent += 10;
      bar.style.width = percent + '%';

      if (percent >= 100) {
        clearInterval(interval);

        // Hide progress bar after short delay
        setTimeout(() => {
          progress.style.display = 'none';
          bar.style.width = '0%';
        }, 800);
      }
    }, 120);
  });


/////////////////// for product page upload btn //////////////////
Shoppad.$(function () {

  let fakeInterval;

  // Inject progress bar when form appears
  var observer = new MutationObserver(function () {
    var $form = Shoppad.$('#uploadery-container form[data-uploadery]');
    if ($form.length && !$form.find('.upload-progress').length) {
      $form.append(
        '<div class="upload-progress"><div class="upload-progress-bar"></div></div>'
      );
       $form.append(
        '<p id="message" style="display:none; color:green; margin-top:0px; font-size:14px;">Logo uploaded successfully!</p>'
      );
    }
  });

  var container = document.getElementById('uploadery-container');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }

  // Start fake progress on file select
  Shoppad.$(document).on('change', 'form[data-uploadery] input[type="file"]', function () {
    var $form = Shoppad.$(this).closest('form');
    var $progress = $form.find('.upload-progress');
    var $bar = $form.find('.upload-progress-bar');

    $progress.show();
    $bar.css('width', '0%');

    let percent = 0;
    fakeInterval = setInterval(function () {
      percent += 5;
      if (percent <= 90) {
        $bar.css('width', percent + '%');
      }
    }, 200);
  });

  // Upload success → complete + hide
  Shoppad.$(document).on('uploadSuccess', 'form[data-uploadery]', function () {
    clearInterval(fakeInterval);

    var $form = Shoppad.$(this);
    var $progress = $form.find('.upload-progress');
    var $bar = $form.find('.upload-progress-bar');
     var $sms = $form.find('#message');
    $sms.show();
    $bar.css('width', '100%');

    // Hide after short delay
    setTimeout(function () {
      $progress.fadeOut(300, function () {
        $bar.css('width', '0%');
      });
    }, 800);
  });

});


Shoppad.$(function() {
  Shoppad.$(document).on('uploadSuccess', 'form[data-uploadery]', function(e) {
    var uploaderyFileName = e.originalEvent.detail.file.match(/[^\/]+$/)[0];
    uploaderyFileName = uploaderyFileName.substr(uploaderyFileName.indexOf('-') + 1);
    var $uploaderyActiveField = Shoppad.$(e.target);
    $uploaderyActiveField.addClass('upload-complete');

    if ($uploaderyActiveField.find('div')[0].childNodes[0].nodeType === 3) {
      $uploaderyActiveField.find('div')[0].childNodes[0].nodeValue = uploaderyFileName;
    } else {
      var uploaderyFileNameNode = document.createTextNode(uploaderyFileName);
      Shoppad.$(uploaderyFileNameNode).insertBefore($uploaderyActiveField.find('input'));
    }
  });
});



///////////////////// Discount price update with App /////////////////////////
(function () {

  function getDiscountForQty(qty) {
    var discount = 0;
    var rows = document.querySelectorAll('.qb-discount-table-row');

    if (!rows.length) return discount;

    rows.forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (cells.length < 2) return;

      var rowQty = parseInt(cells[0].textContent.trim(), 10);
      var rowDiscount = parseFloat(cells[1].textContent.replace('%', ''));

      if (!isNaN(rowQty) && qty >= rowQty) {
        discount = rowDiscount;
      }
    });

    return discount;
  }

  function getBasePrice() {
    var checked = document.querySelector('.swatch-element input:checked');
    if (checked) {
      var swatch = checked.closest('.swatch-element');
      if (swatch && swatch.dataset.price) {
        return parseFloat(swatch.dataset.price);
      }
    }
    return 0;
  }

  function getComparePrice() {
    var checked = document.querySelector('.swatch-element input:checked');
    if (checked) {
      var swatch = checked.closest('.swatch-element');
      if (swatch && swatch.dataset.compPrice) {
        return parseFloat(swatch.dataset.compPrice);
      }
    }
    return 0;
  }

  function updatePrice() {
    var container = document.querySelector('.price-quantity');
    if (!container) return;

    var qtyInput = container.querySelector('.quantity');
    if (!qtyInput) return;

    var qty = parseInt(qtyInput.value, 10);
    if (!qty || qty < 1) qty = 1;

    var basePrice = getBasePrice();
    var comparePrice = getComparePrice();
    if (!basePrice) return;

    var discount = getDiscountForQty(qty);

    // discount dono par apply
    var finalUnitPrice = basePrice * (1 - discount / 100);
    var finalCompareUnit = comparePrice * (1 - discount / 100);

    var priceEl = container.querySelector('.price-ui .price .money');
    var compareEl = container.querySelector('.price-ui .compare-at-price .money');

    if (priceEl) {
      priceEl.textContent = '$' + (finalUnitPrice * qty).toFixed(2);
    }

    if (compareEl) {
      if (comparePrice && comparePrice > basePrice) {
        compareEl.textContent = '$' + (finalCompareUnit * qty).toFixed(2);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  // 🔥 Wait for discount table from app
  function watchDiscountTable() {
    if (document.querySelector('.qb-discount-table-row')) {
      updatePrice();
      return;
    }

    var observer = new MutationObserver(function (mutations, obs) {
      if (document.querySelector('.qb-discount-table-row')) {
        updatePrice();
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {

    updatePrice();          // initial price
    watchDiscountTable();   // wait for app table

    // qty typing
    document.addEventListener('input', function (e) {
      if (e.target.matches('.price-quantity .quantity')) {
        updatePrice();
      }
    });

    // qty buttons
    document.addEventListener('click', function (e) {
      if (e.target.closest('.price-quantity .js-change-quantity')) {
        setTimeout(updatePrice, 120);
      }
    });

    // variant change
    document.addEventListener('change', function (e) {
      if (e.target.matches('.swatch-element input[type="radio"]')) {
        setTimeout(updatePrice, 200);
      }
    });

  });

})();



////////////////////////////////////////////////////////////////
// (function () {

//   function getDiscountForQty(qty) {
//     var discount = 0;
//     var rows = document.querySelectorAll('.qb-discount-table-row');

//     if (!rows.length) return discount;

//     rows.forEach(function (row) {
//       var cells = row.querySelectorAll('td');
//       if (cells.length < 2) return;

//       var rowQty = parseInt(cells[0].textContent.trim(), 10);
//       var rowDiscount = parseFloat(cells[1].textContent.replace('%', ''));

//       if (!isNaN(rowQty) && qty >= rowQty) {
//         discount = rowDiscount;
//       }
//     });

//     return discount;
//   }

//   function updatePrice() {
//     var container = document.querySelector('.price-quantity');
//     if (!container) return;

//     var qtyInput = container.querySelector('.quantity');
//     var priceWrap = container.querySelector('.modal_price');

//     if (!qtyInput || !priceWrap) return;

//     var qty = parseInt(qtyInput.value, 10);
//     if (!qty || qty < 1) qty = 1;

//     var basePrice = parseFloat(priceWrap.dataset.price);
//     if (!basePrice) return;

//     var discount = getDiscountForQty(qty);
//     var finalUnitPrice = basePrice * (1 - discount / 100);

//     var priceEl = container.querySelector('.price-ui .price .money');
//     var compareEl = container.querySelector('.price-ui .compare-at-price .money');
//     //var basePrice = parseFloat(priceWrap.data('price'));
//     //var baseCompare = parseFloat(priceWrap.data('comp-price'));
//     if (priceEl) {
//       priceEl.textContent = '$' + (finalUnitPrice * qty).toFixed(2);
//     }

//     if (compareEl) {
//       if (discount > 0) {
//         compareEl.textContent = '$' + (basePrice * qty).toFixed(2);
//         compareEl.style.display = '';
//       } else {
//         compareEl.style.display = 'none';
//       }
//     }
//   }

//   /* -----------------------------
//      SAFE table watcher
//   ------------------------------ */

//   function waitForDiscountTable() {
//     if (document.querySelector('.qb-discount-table-row')) {
//       updatePrice();
//       return; // already exists
//     }

//     var observer = new MutationObserver(function (mutations, obs) {
//       if (document.querySelector('.qb-discount-table-row')) {
//         updatePrice();
//         obs.disconnect(); // 🔑 STOP observing
//       }
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     updatePrice();
//     waitForDiscountTable();

//     document.addEventListener('input', function (e) {
//       if (e.target.matches('.price-quantity .quantity')) {
//         updatePrice();
//       }
//     });

//     document.addEventListener('click', function (e) {
//       if (e.target.closest('.price-quantity .js-change-quantity')) {
//         setTimeout(updatePrice, 120);
//       }
//     });

    
//   });

// })();

///////////////////////////////////////////////////////////////////////////////////////////////////////
// (function ($) {

//   function getDiscountForQty(qty) {
//     var discount = 0;

//     $('.qb-discount-table-row').each(function () {
//       var rowQty = parseInt($(this).find('td').eq(0).text(), 10);
//       var rowDiscount = parseFloat(
//         $(this).find('td').eq(1).text().replace('%', '')
//       );

//       if (qty >= rowQty) {
//         discount = rowDiscount;
//       }
//     });

//     return discount;
//   }

//   function updatePrice() {
//     var qty = parseInt($('.price-quantity .quantity').val(), 10);
//     if (!qty || qty < 1) qty = 1;

//     var container = $('.price-quantity');
//     var priceWrap = container.find('.modal_price');

//     var basePrice = parseFloat(priceWrap.data('price'));
//     var baseCompare = parseFloat(priceWrap.data('comp-price'));

//     if (!basePrice) return;

//     var discount = getDiscountForQty(qty);
//     var discountedUnitPrice = basePrice * (1 - discount / 100);

//     var priceEl = container.find('.price-ui .price .money');
//     var compareEl = container.find('.price-ui .compare-at-price .money');

//     // Total prices
//     var finalPrice = discountedUnitPrice * qty;
//     var comparePrice = basePrice * qty;

//     priceEl.text('$' + finalPrice.toFixed(2));

//     if (compareEl.length && discount > 0) {
//       compareEl.text('$' + comparePrice.toFixed(2));
//       compareEl.show();
//     } else {
//       compareEl.hide();
//     }
//   }

//   // Quantity input
//   $(document).on('input', '.price-quantity .quantity', updatePrice);

//   // Plus / minus buttons
//   $(document).on('click', '.price-quantity .js-change-quantity', function () {
//     setTimeout(updatePrice, 120);
//   });

//   // Initial run
//   setTimeout(updatePrice, 200);

// })(jQuery);

//   (function ($) {

//     function updatePrice() {
//       var qty = parseInt($('.price-quantity .quantity').val(), 10);
//       if (!qty || qty < 1) qty = 1;

//       var container = $('.price-quantity');
//       var priceWrap = container.find('.modal_price');

//       var basePrice = parseFloat(priceWrap.data('price'));
//       var baseCompare = parseFloat(priceWrap.data('comp-price'));

//       if (!basePrice) return;

//       var priceEl = container.find('.price-ui .price .money');
//       var compareEl = container.find('.price-ui .compare-at-price .money');

//       // Update UI
//       priceEl.text('$' + (basePrice * qty).toFixed(2));

//       if (compareEl.length && baseCompare) {
//         compareEl.text('$' + (baseCompare * qty).toFixed(2));
//       }
//     }

//     // Quantity input
//     $(document).on('input', '.price-quantity .quantity', updatePrice);

//     // Plus / minus buttons
//     $(document).on('click', '.price-quantity .js-change-quantity', function () {
//       setTimeout(updatePrice, 120);
//     });

//     // Initial run
//     setTimeout(updatePrice, 200);

//   })(jQuery);
/////////////////////////////////////////////////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.js-read-more');
  const desc = document.querySelector('.js-coll-desc');

  if (!btn || !desc) return;

  btn.addEventListener('click', function () {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
    desc.classList.toggle('is-expanded');
    btn.textContent = expanded ? 'Read more' : 'Read less';
  });
});


function updateAsLowAsFromSelect() {

  const selectEl = document.querySelector('select.multi_select');
  if (!selectEl) return;

  // Get selected swatch values
  const selectedOption0 = document.querySelector('.swatch-0 .swatch-element input:checked');
  const selectedOption1 = document.querySelector('.swatch-1 .swatch-element input:checked');

  if (!selectedOption0 || !selectedOption1) return;

  const option0Value = selectedOption0.value.trim();
  const option1Value = selectedOption1.value.trim();

  console.log('Selected Option 0:', option0Value);
  console.log('Selected Option 1:', option1Value);

  // Loop through select options
  const matchedOption = Array.from(selectEl.options).find(opt => {
    const text = opt.text.trim();
    if (!text.includes('/')) return false;

    const [beforeSlash, afterSlash] = text.split('/').map(v => v.trim());

    return (
      beforeSlash === option0Value &&
      afterSlash === option1Value
    );
  });

  if (!matchedOption) {
    console.warn('No matching variant found');
    return;
  }

  const lowAsPrice = matchedOption.getAttribute('data-low-as');

  console.log('Matched Variant:', matchedOption.value);
  console.log('As low as:', lowAsPrice);

  // Update global price display
  if (lowAsPrice) {
    const globalPriceEl = document.querySelector('.as-low-as span:last-child');
    if (globalPriceEl) {
      globalPriceEl.innerText = lowAsPrice;
    }
  }

  // Update price inside option-1 swatch only
  const option1Swatch = selectedOption1.closest('.swatch-element');
  if (option1Swatch && lowAsPrice) {
    const swatchPriceEl = option1Swatch.querySelector('.as-low-as span:last-child');
    if (swatchPriceEl) {
      swatchPriceEl.innerText = lowAsPrice;
    }
  }
}

// Bind change
document.querySelectorAll('.swatch-element label input').forEach(input => {
  input.addEventListener('change', updateAsLowAsFromSelect);
});

// Run on load
updateAsLowAsFromSelect();


// document.querySelectorAll('.footer_menu h6').forEach(el => {
//   el.addEventListener('click', event => {
//     event.preventDefault();
//     event.stopPropagation();
//   });
// });

//  const quantityInput = document.getElementById('quantity');

//   function formatQuantity() {
//     let value = parseInt(quantityInput.value, 10);
//     if (isNaN(value) || value < 1) value = 1;
//     quantityInput.value = value < 10 ? '0' + value : value;
//   }

//   formatQuantity();

//   ['input', 'change', 'blur', 'keyup', 'mouseup'].forEach(evt => {
//     quantityInput.addEventListener(evt, () => {
//       setTimeout(formatQuantity, 10);
//     });
//   });

$(document).ready(function() {
   if ($('body.product-product-page-2').length) {
    $('.product-block--first, .product-block--title, .product-block--form, .product-block--features, .product-block--sku').wrapAll('<div class="first-title-wrapper"></div>');  
    $('.product-block--collapsible-tab').wrapAll('<div class="second-tabs-wrapper"></div>');
   }
  });

//////////////////// second-side carve ATC button ///////////////////////

// document.addEventListener("DOMContentLoaded", function () {

//   const addToCartBtn = document.querySelector(".add_to_cart-1");
//   const checkbox = document.getElementById("second-side-checkbox");
//   const textWrap = document.querySelector("#uploadery-container");
//   const sstextWrap = document.querySelector("#second-side-text-wrap");
//     if (checkbox && textWrap) {
//       checkbox.addEventListener("change", () => {
//         textWrap.classList.toggle("active", checkbox.checked);     
//       });
//     }

//       // Show/hide text input with smooth transition using JS
//       if (checkbox && sstextWrap) {
//         sstextWrap.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
//         sstextWrap.style.overflow = "hidden";
//         sstextWrap.style.maxHeight = "0";
//         sstextWrap.style.opacity = "0";
//         sstextWrap.style.display = "none"; // hidden initially

//         checkbox.addEventListener("change", function () {
//           if (this.checked) {
//             sstextWrap.style.display = "block"; // make visible to measure height
//             const scrollHeight = sstextWrap.scrollHeight;

//             // Temporarily disable transitions to reset height instantly
//             sstextWrap.style.transition = "none";
//             sstextWrap.style.maxHeight = "0";
//             requestAnimationFrame(() => {
//               // Re-enable transition
//               sstextWrap.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
//               sstextWrap.style.maxHeight = scrollHeight + "px";
//               sstextWrap.style.opacity = "1";
//             });
//           } else {
//             sstextWrap.style.maxHeight = "0";
//             sstextWrap.style.opacity = "0";
//             setTimeout(() => {
//               if (!checkbox.checked) {
//                 sstextWrap.style.display = "none";
//               }
//             }, 300);
//           }
//         });
//       }

//     if (addToCartBtn) {
//     addToCartBtn.addEventListener("click", function () {
//       setTimeout(function () {
//         if (checkbox && checkbox.checked) 
//         {
//           const carveBox = document.querySelector(".second-side-carve-options");
//           const secondSideText = document.getElementById("second-side-text")?.value?.trim();
//           const freeProductId = carveBox?.getAttribute("data-product-id")?.trim();
//           const mainProductName = carveBox?.getAttribute("data-main-product-name")?.trim();
//           const mainProductId = carveBox?.getAttribute("data-main-product-id")?.trim();

//           const quantityInput = document.querySelector(".count");
//           const quantity = parseInt(quantityInput?.value?.trim() || "1");

//           if (!freeProductId || !mainProductId) {
//             console.warn("Missing required product IDs.");
//             return;
//           }

//           const payload = {
//             id: parseInt(freeProductId),
//             quantity: quantity,
//             properties: {
//               "Second Side Text": secondSideText || "",
//               "Main Product Name": mainProductName || "Unknown Product",
//               "Main Product ID": mainProductId // Hidden in cart but useful for syncing
//             }
//           };

//           fetch("/cart/add.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json"
//             },
//             body: JSON.stringify(payload)
//           })
//           .then(res => res.json())
//           .then(data => {
//             console.log("✅ Second-side carve product added:", data);
//             // Optional: Reload cart or show confirmation here
//           })
//           .catch(err => {
//             console.error("❌ Error adding second-side carve product:", err);
//           });
//         }
//       }, 500); // Give time for first product to be added
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  console.log("📦 Script loaded");

  $(document).ajaxSuccess(function(event, xhr, options) {
    if(options.url.indexOf("/discount_codes/apply") != -1)
    {
        //console.log(options.url);
        location.reload(true);
    }
  });

  const ajaxBtn = document.querySelector(".ajax-submit-button");
  const productForm = document.querySelector("form.shopify-product-form");

  const checkbox = document.getElementById("second-side-checkbox");
  const textWrap = document.querySelector("#uploadery-container");
  const sstextWrap = document.querySelector("#second-side-text-wrap");

  /* --------------------------
     Toggle upload container
  --------------------------- */
  if (checkbox && textWrap) {
    checkbox.addEventListener("change", () => {
      textWrap.classList.toggle("active", checkbox.checked);
    });
  }

  /* --------------------------
     Animate text field
  --------------------------- */
  if (checkbox && sstextWrap) {
    sstextWrap.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
    sstextWrap.style.overflow = "hidden";
    sstextWrap.style.maxHeight = "0";
    sstextWrap.style.opacity = "0";
    sstextWrap.style.display = "none";

    checkbox.addEventListener("change", function () {
      if (this.checked) {
        sstextWrap.style.display = "block";
        const h = sstextWrap.scrollHeight;

        sstextWrap.style.transition = "none";
        sstextWrap.style.maxHeight = "0";

        requestAnimationFrame(() => {
          sstextWrap.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
          sstextWrap.style.maxHeight = h + "px";
          sstextWrap.style.opacity = "1";
        });
      } else {
        sstextWrap.style.maxHeight = "0";
        sstextWrap.style.opacity = "0";
        setTimeout(() => {
          if (!checkbox.checked) sstextWrap.style.display = "none";
        }, 300);
      }
    });
  }

  /* --------------------------
     AJAX Add to Cart Flow
  --------------------------- */
  if (ajaxBtn && productForm) {
    ajaxBtn.addEventListener("click", function (e) {
      e.preventDefault(); // 🚫 stop default submit
      console.log("🛒 AJAX add to cart triggered");

      const formData = new FormData(productForm);

      // 1️⃣ Add MAIN product
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json"
        }
      })
        .then(res => res.json())
        .then(mainItem => {
          console.log("✅ Main product added:", mainItem);

          // If second-side not selected → redirect
          if (!checkbox || !checkbox.checked) {
            window.location.href = "/cart";
            return;
          }

          // 2️⃣ Add SECOND-SIDE product
          const carveBox = document.querySelector(".second-side-carve-options");
          const secondSideText = document.getElementById("second-side-text")?.value?.trim();
          const freeProductId = carveBox?.getAttribute("data-product-id");
          const mainProductName = carveBox?.getAttribute("data-main-product-name");
          const mainProductId = carveBox?.getAttribute("data-main-product-id");

          const quantity = parseInt(
            productForm.querySelector('[name="quantity"]')?.value || "1",
            10
          );

          if (!freeProductId) {
            console.warn("❌ Missing second-side product ID");
            window.location.href = "/cart";
            return;
          }

          const payload = {
            id: parseInt(freeProductId, 10),
            quantity: quantity,
            properties: {
              "Second Side Text": secondSideText || "",
              "Main Product Name": mainProductName || "",
              "Main Product ID": mainProductId || ""
            }
          };

          console.log("📤 Adding second-side product:", payload);

          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(payload)
          });
        })
        .then(res => res && res.json())
        .then(secondItem => {
          if (secondItem) {
            console.log("✅ Second-side product added:", secondItem);
          }
          // 3️⃣ Redirect after both
          window.location.href = "/cart";
        })
        .catch(err => {
          console.error("❌ Add to cart error:", err);
        });
    });
  }
});

// document.addEventListener("DOMContentLoaded", function () {

//   const addToCartBtn = document.querySelector(".add_to_cart-1");
//   const checkbox = document.getElementById("second-side-checkbox");
//   const textWrap = document.querySelector("#uploadery-container");
//   const sstextWrap = document.querySelector("#second-side-text-wrap");

//   console.log("Add to cart button:", addToCartBtn);
//   console.log("Checkbox:", checkbox);
//   console.log("Upload container:", textWrap);
//   console.log("Second-side text wrap:", sstextWrap);

//   /* --------------------------
//      Toggle upload container
//   --------------------------- */
//   if (checkbox && textWrap) {
//     checkbox.addEventListener("change", () => {
//       console.log("Checkbox changed:", checkbox.checked);
//       textWrap.classList.toggle("active", checkbox.checked);
//     });
//   }

//   /* --------------------------
//      Animate text field
//   --------------------------- */
//   if (checkbox && sstextWrap) {
//     sstextWrap.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
//     sstextWrap.style.overflow = "hidden";
//     sstextWrap.style.maxHeight = "0";
//     sstextWrap.style.opacity = "0";
//     sstextWrap.style.display = "none";

//     checkbox.addEventListener("change", function () {
//       console.log("Second-side text toggle:", this.checked);

//       if (this.checked) {
//         sstextWrap.style.display = "block";
//         const scrollHeight = sstextWrap.scrollHeight;

//         sstextWrap.style.transition = "none";
//         sstextWrap.style.maxHeight = "0";

//         requestAnimationFrame(() => {
//           sstextWrap.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
//           sstextWrap.style.maxHeight = scrollHeight + "px";
//           sstextWrap.style.opacity = "1";
//         });
//       } else {
//         sstextWrap.style.maxHeight = "0";
//         sstextWrap.style.opacity = "0";
//         setTimeout(() => {
//           if (!checkbox.checked) {
//             sstextWrap.style.display = "none";
//           }
//         }, 300);
//       }
//     });
//   }

//   /* --------------------------
//      Add second-side product
//   --------------------------- */
//   if (addToCartBtn) {
//     addToCartBtn.addEventListener("click", function () {
//       console.log("🛒 Add to cart clicked");

//       setTimeout(function () {
//         if (!checkbox || !checkbox.checked) {
//           console.log("Second-side not selected, skipping add-on");
//           return;
//         }

//         const carveBox = document.querySelector(".second-side-carve-options");
//         const secondSideText = document.getElementById("second-side-text")?.value?.trim();
//         const freeProductId = carveBox?.getAttribute("data-product-id")?.trim();
//         const mainProductName = carveBox?.getAttribute("data-main-product-name")?.trim();
//         const mainProductId = carveBox?.getAttribute("data-main-product-id")?.trim();

//         const quantityInput = document.querySelector(".count");
//         const quantity = parseInt(quantityInput?.value || "1", 10);

//         console.log("Second-side carve data:", {
//           freeProductId,
//           mainProductName,
//           mainProductId,
//           quantity,
//           secondSideText
//         });

//         if (!freeProductId || !mainProductId) {
//           console.warn("❌ Missing required product IDs");
//           return;
//         }

//         const payload = {
//           id: parseInt(freeProductId, 10),
//           quantity: quantity,
//           properties: {
//             "Second Side Text": secondSideText || "",
//             "Main Product Name": mainProductName || "Unknown Product",
//             "Main Product ID": mainProductId
//           }
//         };

//         console.log("📤 Sending payload:", payload);

//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json"
//           },
//           body: JSON.stringify(payload)
//         })
//           .then(res => {
//             console.log("Add-on response status:", res.status);
//             return res.json();
//           })
//           .then(data => {
//             console.log("✅ Second-side carve product added:", data);
          
//               // 🔁 REDIRECT TO CART AFTER SUCCESS
//               window.location.href = "/cart";
//             refreshCart();
//           })
//           .catch(err => {
//             console.error("❌ Error adding second-side carve product:", err);
//           });

//       }, 100); // wait for main product add
//     });
//   }
// });


/////////////////// cart page ////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const clickedRemoveBtn = e.target.closest(".cart__remove-btn");
    if (!clickedRemoveBtn) return;

    // Find the main cart item row
    const mainCartItem = clickedRemoveBtn.closest(".cart__item");
    const mainItemKey = mainCartItem?.getAttribute("data-cart-item-key");

    if (!mainItemKey) return;

    // Extract the product ID from the cart-item-key (format: variant_id:token)
    const mainProductId = mainItemKey.split(":")[0];

    console.log("🧹 Removing MAIN item:", mainItemKey);

    // Remove the main product
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: mainItemKey, quantity: 0 })
    })
    .then(res => res.json())
    .then(() => {
      // 🔁 Wait for DOM/cart animation to finish before removing the add-on
      setTimeout(() => {
        const allCartItems = document.querySelectorAll(".cart__item");

        for (const item of allCartItems) {
          if (item === mainCartItem) continue;

          const hiddenOption = item.querySelector("li.cart__product-option.hidden[data-main-product-id]");
          const linkedMainId = hiddenOption?.getAttribute("data-main-product-id");

          if (linkedMainId === mainProductId) {
            const addonItemKey = item.getAttribute("data-cart-item-key");

            if (addonItemKey) {
              console.log("🗑️ Removing matched ADD-ON item:", addonItemKey);

              fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: addonItemKey, quantity: 0 })
              }).then(() => {
                // Optionally reload to reflect changes
                location.reload();
              });
            }
            break; // Stop after first matched add-on
          }
        }
      }, 500); // Adjust delay as needed
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.addEventListener("change", function (e) {
//     const quantityInput = e.target.closest(".cart-item-quantity");
//     if (!quantityInput) return;

//     const mainCartItem = quantityInput.closest(".cart__item");
//     const mainItemKey = mainCartItem?.getAttribute("data-cart-item-key");
//     const newQuantity = parseInt(quantityInput.value, 10);

//     if (!mainItemKey || isNaN(newQuantity)) return;

//     // Update main product quantity
//     fetch("/cart/change.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ id: mainItemKey, quantity: newQuantity })
//     })
//     .then(res => res.json())
//     .then(() => {
//       // Extract main product ID
//       const mainProductId = mainItemKey.split(":")[0];

//       // Loop through other cart items to find a matching add-on
//       const allCartItems = document.querySelectorAll(".cart__item");
//       for (const item of allCartItems) {
//         if (item === mainCartItem) continue;

//         const hiddenOption = item.querySelector("li.cart__product-option.hidden[data-main-product-id]");
//         const linkedMainId = hiddenOption?.getAttribute("data-main-product-id");

//         if (linkedMainId === mainProductId) {
//           const addonItemKey = item.getAttribute("data-cart-item-key");
//           if (!addonItemKey) continue;

//           console.log(`🔄 Updating add-on (${addonItemKey}) quantity to ${newQuantity}`);

//           // Update add-on quantity
//           fetch("/cart/change.js", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ id: addonItemKey, quantity: newQuantity })
//           }).then(() => {
//             location.reload(); // Reload to reflect updated quantities
//           });

//           break; // Stop after updating first matched add-on
//         }
//       }
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", function () {

  /**
   * 🔹 Sync add-ons to match a main product quantity
   * Returns a Promise that resolves after all add-ons are updated.
   */
  function syncAddons(mainCartItem, newQuantity) {
    const mainItemKey = mainCartItem.getAttribute("data-cart-item-key");
    const mainProductId = mainItemKey?.split(":")[0];
    if (!mainProductId) return Promise.resolve();

    const allCartItems = document.querySelectorAll(".cart__item");
    const updatePromises = [];

    allCartItems.forEach(item => {
      if (item === mainCartItem) return;

      const hiddenOption = item.querySelector("li.cart__product-option.hidden[data-main-product-id]");
      const linkedMainId = hiddenOption?.getAttribute("data-main-product-id");
      if (linkedMainId === mainProductId) {
        const addonItemKey = item.getAttribute("data-cart-item-key");
        if (!addonItemKey) return;

        console.log(`🔄 Syncing add-on (${addonItemKey}) → ${newQuantity}`);

        const p = fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: addonItemKey, quantity: newQuantity })
        })
          .then(r => r.json())
          .then(() => console.log("✅ Add-on updated"))
          .catch(err => console.error("❌ Add-on update failed", err));

        updatePromises.push(p);
      }
    });

    // Wait for all updates before resolving
    return Promise.all(updatePromises);
  }

  /**
   * 🔹 Handle +/- buttons for main products only
   */
  $(document)
    .off("click.cartSync")
    .on("click.cartSync", ".js-change-quantityy", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // ✅ Prevent duplicate theme click handlers

      const $btn = $(this);
      const $box = $btn.closest(".product-quantity-box");
      const $input = $box.find(".cart-item-quantity");
      const cartItem = $btn.closest(".cart__item");
      if (!$input.length || !cartItem.length) return;

      // Skip add-ons (only listen to main products)
      const isAddon = cartItem.find("li.cart__product-option.hidden[data-main-product-id]").length > 0;
      if (isAddon) return;

      const func = $btn.data("func"); // "plus" or "minus"
      let val = parseInt($input.val(), 10) || 0;
      val = func === "plus" ? val + 1 : val - 1;

      // Respect min/max if set
      const min = parseInt($input.attr("min"), 10);
      const max = parseInt($input.attr("max"), 10);
      if (!isNaN(min)) val = Math.max(val, min);
      if (!isNaN(max)) val = Math.min(val, max);
      if (val < 0) val = 0;

      console.log(`🔘 ${func} clicked → ${val}`);

      // ✅ Disable both +/- temporarily to avoid rapid clicks
      $box.find(".js-change-quantityy").addClass("is-disabled");

      // Update visible field
      $input.val(val);

      const mainItemKey = cartItem.data("cart-item-key");
      if (!mainItemKey) return;

      // Update main product first
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: mainItemKey, quantity: val })
      })
        .then(res => res.json())
        .then(() => {
          console.log("✅ Main product updated");
          return syncAddons(cartItem[0], val); // update add-ons next
        })
        .then(() => {
          console.log("🔃 All synced → Reloading...");
          setTimeout(() => location.reload(), 300);
        })
        .catch(err => console.error("❌ Update failed", err))
        .finally(() => {
          // ✅ Re-enable buttons after short delay
          setTimeout(() => {
            $box.find(".js-change-quantityy").removeClass("is-disabled");
          }, 800);
        });
    });

  /**
   * 🔹 On manual quantity change in input field
   */
  $(document).on("change.cartSync", ".cart-item-quantity", function () {
    const $input = $(this);
    const cartItem = $input.closest(".cart__item");
    if (!cartItem.length) return;

    // Skip add-ons
    const isAddon = cartItem.find("li.cart__product-option.hidden[data-main-product-id]").length > 0;
    if (isAddon) return;

    const newQuantity = parseInt($input.val(), 10);
    if (isNaN(newQuantity)) return;

    console.log("📦 Main product manually changed →", newQuantity);

    const mainItemKey = cartItem.data("cart-item-key");
    if (!mainItemKey) return;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: mainItemKey, quantity: newQuantity })
    })
      .then(res => res.json())
      .then(() => syncAddons(cartItem[0], newQuantity))
      .then(() => location.reload())
      .catch(err => console.error("❌ Manual change failed", err));
  });

});


$("[data-cart-checkout-button1]").on("click",function(e){
  e.preventDefault();
  $(".checkout-error").hide();
  const sampleQuantity = parseInt($(".sample-item").attr("data-quantity"));
  const itemCount = $(".cart__item").length;

  console.log(sampleQuantity, itemCount > 1, !isNaN(sampleQuantity));

  if((sampleQuantity > 1 && !isNaN(sampleQuantity)) || (itemCount > 1 && !isNaN(sampleQuantity)))
  {
    console.log("error");
    $(".checkout-error").show();
    return;
  }
  else
  {
     $(this).attr("disabled","");
     $("[data-cart-checkout-button]").trigger("click");
  }
});